import React from "react";
import AboutSection from "../Components/AboutSection";

const FacilityGallery = () => {
  const images = [
    "./img/about_img (1).jpeg",
    "./img/about_img (2).jpeg"
  ];

  return (
    <section className="py-12 bg-slate-50 border-t border-b border-slate-100">
      <div className="max-w-2xl mx-auto px-4">
        <div className="text-center mb-8">
          <h3 className="text-lg font-semibold text-slate-500 uppercase tracking-widest">
            Facility Gallery & Offerings
          </h3>
          <p className="text-slate-600 text-sm mt-1">
            Detailed overview of our safety inspection capabilities, training sessions, and Director profile
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {images.map((src, idx) => (
            <div key={idx} className="border-4 border-white rounded-3xl shadow-lg overflow-hidden bg-white hover:shadow-xl transition-all duration-300 max-w-[280px] sm:max-w-[300px] mx-auto">
              <img
                src={src}
                alt={`HMT Facility & Offering ${idx + 1}`}
                className="w-full h-auto object-contain block"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const TeamSection = () => {
  return (
    <section className="py-12 px-4 bg-slate-50 border-t border-b border-slate-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-extrabold text-slate-800 tracking-tight">
            Our Technical Experts & Leadership
          </h2>
          <p className="text-slate-500 text-xs mt-1 max-w-xl mx-auto">
            Qualified competent persons, safety auditors, and EHS consultants with decades of direct field experience.
          </p>
        </div>

        {/* 3-Column Core Team */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {/* Mr. Piyush Tiwari */}
          <div className="bg-white p-5 rounded-xl border border-slate-100 shadow-sm flex flex-col justify-between">
            <div>
              <span className="text-[10px] font-bold text-blue-600 uppercase tracking-widest block mb-1">Director</span>
              <h3 className="text-base font-bold text-slate-800">Mr. Piyush Tiwari</h3>
            </div>
            <p className="text-slate-500 text-xs mt-2 font-light">PGDFS</p>
          </div>

          {/* Mr. R.P. Pandey */}
          <div className="bg-white p-5 rounded-xl border border-slate-100 shadow-sm flex flex-col justify-between">
            <div>
              <span className="text-[10px] font-bold text-blue-600 uppercase tracking-widest block mb-1">Chief Technical Manager</span>
              <h3 className="text-base font-bold text-slate-850">Mr. R.P. Pandey</h3>
            </div>
            <p className="text-slate-500 text-xs mt-2 font-light">Competent Person (Factories Act 1948)</p>
          </div>

          {/* Mr. Pankaj Pal */}
          <div className="bg-white p-5 rounded-xl border border-slate-100 shadow-sm flex flex-col justify-between">
            <div>
              <span className="text-[10px] font-bold text-blue-600 uppercase tracking-widest block mb-1">General Manager</span>
              <h3 className="text-base font-bold text-slate-850">Mr. Pankaj Pal</h3>
            </div>
            <p className="text-slate-500 text-xs mt-2 font-light">Operations & Management</p>
          </div>
        </div>

        {/* 2-Column Auditors & Consultant */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
          {/* EHS Consultant */}
          <div className="bg-white p-5 rounded-xl border border-slate-100 shadow-sm md:col-span-2">
            <div className="flex justify-between items-start flex-wrap gap-2">
              <div>
                <span className="text-[10px] font-bold text-blue-600 uppercase tracking-widest block mb-1">Senior EHS Consultant</span>
                <h3 className="text-base font-bold text-slate-850">Mr. Bhupesh H. Upadhyay</h3>
              </div>
              <p className="text-slate-400 text-xs italic font-light">B. Tech Industrial Engg., PGDIS (RLI-Kanpur)</p>
            </div>
            <p className="text-slate-600 text-xs mt-3 leading-relaxed font-light">
              Lead Auditor ISO-14001, BS:OHSAS-18001. Formerly Vice President EHS at Alembic, GM EHS at Ranbaxy Labs. EHS Consultant to AMRI & Nectar Life Sciences.
            </p>
          </div>

          {/* Safety Auditors */}
          <div className="bg-white p-5 rounded-xl border border-slate-100 shadow-sm md:col-span-2">
            <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest block mb-3">Certified Safety Auditors</span>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div>
                <h5 className="font-bold text-slate-800 text-sm">Mr. B.B. Tiwari</h5>
                <p className="text-slate-500 text-[11px] font-light">Diploma in Industrial Safety (RLI Kanpur)</p>
              </div>
              <div className="border-t sm:border-t-0 sm:border-l border-slate-100 pt-3 sm:pt-0 sm:pl-4">
                <h5 className="font-bold text-slate-800 text-sm">Mr. D. P. Rai</h5>
                <p className="text-slate-500 text-[11px] font-light">B. Tech Mech, HAZOP (RLI Kanpur)</p>
              </div>
              <div className="border-t sm:border-t-0 sm:border-l border-slate-100 pt-3 sm:pt-0 sm:pl-4">
                <h5 className="font-bold text-slate-800 text-sm">Mr. Amit Sharma</h5>
                <p className="text-slate-500 text-[11px] font-light">B. Tech Chemical, PG Dip Safety</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const EquipmentSection = () => {
  const equipments = [
    { icon: "⚖️", title: "Tenso-Meter", desc: "Mechanical & Digital (cap. 20 MT) for lifting gear load tests" },
    { icon: "💧", title: "Hydraulic Pump", desc: "For high-pressure vessel hydrostatic strength tests" },
    { icon: "🔍", title: "Ultrasonic Thickness Meter", desc: "Non-destructive testing (NDT) for vessel walls" },
    { icon: "⚡", title: "Earth Resistance Tester", desc: "Statutory electrical grounding/earthing verification" },
    { icon: "⚙️", title: "Secondary Injection Machine", desc: "For protective relay testing & calibrations" },
    { icon: "📏", title: "Vernier Caliper & Gauges", desc: "Precision dimensional check of mechanical tackles" },
    { icon: "🔬", title: "Magnifying & NDT Gear", desc: "Microstructural inspections of ropes, chains and hooks" },
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-slate-800 tracking-tight">
            Our Testing & Diagnostic Equipments
          </h2>
          <p className="text-slate-600 text-sm mt-2 max-w-2xl mx-auto">
            We own and deploy certified testing instruments to perform precise load testing, thickness checks, and electrical relays calibrations.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 text-center">
          {equipments.map((eq, idx) => (
            <div key={idx} className="p-6 bg-slate-50 rounded-2xl border border-slate-100 hover:shadow-md transition-all duration-300 flex flex-col justify-between">
              <div>
                <div className="text-4xl mb-3">{eq.icon}</div>
                <h4 className="font-bold text-slate-800 text-sm mb-1">{eq.title}</h4>
              </div>
              <p className="text-slate-500 text-[11px] mt-2 leading-relaxed">{eq.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const About = () => {
  return (
    <>
      {/* Minimal Header */}
      <div className="bg-slate-900 text-white py-12 md:py-16 text-center">
        <h1 className="text-2xl md:text-4xl font-extralight tracking-widest uppercase text-slate-100">
          About Us
        </h1>
        <div className="w-16 h-0.5 bg-blue-500 mx-auto mt-3 mb-3"></div>
        <p className="text-slate-400 text-xs md:text-sm max-w-xl mx-auto px-4 font-light leading-relaxed">
          Your Trusted Partner for Third Party Inspection, Safety Audits & Compliance.
        </p>
      </div>

      <AboutSection />

      {/* Facility Image Gallery (Before Core Values) */}
      <FacilityGallery />

      {/* Mission and Quality Policy */}
      <section className="py-20 px-4 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-extrabold text-slate-800 mb-4">
              Our Core Values
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Guiding principles that drive our commitment to excellence
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
            <div className="relative overflow-hidden bg-white rounded-3xl shadow-2xl hover:shadow-blue-50/50 transition-all duration-500 hover:-translate-y-1">
              <div className="p-10">
                <div className="flex items-center gap-4 mb-6">
                  <h3 className="text-3xl font-bold text-slate-800">Our Mission</h3>
                </div>
                <p className="text-slate-700 text-lg leading-relaxed">
                  To provide high-quality statutory Third Party Inspection and safety audit services at affordable cost, keeping customer satisfaction and compliance as our primary motives.
                </p>
              </div>
            </div>
            <div className="relative overflow-hidden bg-white rounded-3xl shadow-2xl hover:shadow-blue-50/50 transition-all duration-500 hover:-translate-y-1">
              <div className="p-10">
                <div className="flex items-center gap-4 mb-6">
                  <h3 className="text-3xl font-bold text-slate-800">Our Vision & Values</h3>
                </div>
                <p className="text-slate-700 text-lg leading-relaxed">
                  To create an organization that takes care of a better, safer future for our customers and community, built on core values of integrity, compassion, continuous learning, and values-driven operations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Invitation Section */}
      <div className="w-[90%] mx-auto my-8 text-justify px-4">
        <p className="text-md text-slate-600 text-justify">
          To better serve your organization's safety and statutory compliance needs, we invite you to share the details of your machinery (lifts, hoists, cranes, pressure plants) or your requirements for safety audits and licensing. This will enable us to tailor our inspections and provide you with a competitive quotation promptly.
        </p>
      </div>

      {/* Team Leadership Section */}
      <TeamSection />

      {/* Testing Equipment Section */}
      <EquipmentSection />

      {WhyChooseUs()}
    </>
  );
};

export default About;

const WhyChooseUs = () => {
  const features = [
    {
      icon: "🏅",
      title: "Quality",
      description: "High quality third-party inspection and safety audit services with customer satisfaction as our priority.",
    },
    {
      icon: "🏗️",
      title: "Statutory Testing",
      description:
        "Authorized competent persons under Factories Act 1948 for testing lifts, hoists, cranes, tackles, and pressure vessels.",
    },
    {
      icon: "📋",
      title: "Safety Audits",
      description:
        "Expert process safety audits, Risk Assessments, HAZOP studies, and On-site/Off-site Emergency plans (DMP).",
    },
    {
      icon: "🤝",
      title: "Liaison & Approvals",
      description:
        "Complete liaison with Factories Department for licensing and PESO for petro-chemical installation approvals.",
    },
    {
      icon: "📧",
      title: "Expert Team",
      description:
        "Specialists, Risk Control Engineers, Third Party Quality Assessors, and Valuers with long-term on-the-job experience.",
    },
    {
      icon: "⏳",
      title: "Prompt Approvals",
      description:
        "Fast response and close coordination with statutory bodies to ensure smooth, timely compliance without delays.",
    },
    {
      icon: "💰",
      title: "Competitive Cost",
      description:
        "Offering the best competitive and affordable pricing for all safety engineering and statutory inspections.",
    },
    {
      icon: "📅",
      title: "Flexible Scheduling",
      description: "We organize inspections and audits around your operating schedules to prevent machine shutdown during work hours.",
    },
    {
      icon: "🚚",
      title: "Wide Coverage",
      description:
        "Active safety audits and TPI services across Uttar Pradesh, Punjab, Delhi, Haryana, and other regions.",
    },
  ];

  return (
    <div className="bg-gradient-to-b from-gray-50 to-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-12 text-gray-800">
          Why HMT Technical Services?
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center bg-white p-8 shadow-xl rounded-2xl hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300 border border-gray-100"
            >
              <div className="text-6xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-blue-700 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
